module.exports = __webpack_public_path__ + "../resources/images/DragToCalendar-97bebea4baa8d5fcb63c5c81e15ca54d.gif";